module.exports = __webpack_public_path__ + "static/img/img_20.3fce9db6.png";